import { camel2UnderScore, underScore2Camel } from '../utils';
import { Logger } from '@tencent/logger';
// 实体的id， 这个jsonObj不解析
var UUID_KEY = 'id';
/**
 * Domain Data Base类
 * 提供用jsonObj to class、  class to jsonObj序列化的基类
 */
var DDBase = /** @class */ (function () {
    function DDBase() {
    }
    DDBase.prototype.jsonObj2Class = function (jsonObj, jsonObjIsCamelType) {
        var _this = this;
        if (!jsonObj) {
            DDBase.logger.debug('params erroro: jsonObj2Class');
            return;
        }
        var keys = Object.keys(jsonObj);
        keys.forEach(function (key) {
            var camelKey = key;
            if (!jsonObjIsCamelType) {
                camelKey = underScore2Camel(key);
            }
            if (Object.prototype.hasOwnProperty.call(_this, camelKey)) {
                // 类型嵌套的情况处理
                if (_this[camelKey] instanceof DDBase) {
                    _this[camelKey].jsonObj2Class(jsonObj[key]);
                }
                else {
                    _this[camelKey] = jsonObj[key];
                }
            }
        });
    };
    DDBase.prototype.class2JsonObj = function (jsonObjIsCamelType) {
        var _this = this;
        var result = {};
        var keys = Object.keys(this);
        keys.forEach(function (key) {
            if (key !== UUID_KEY) {
                var underScoreKey = key;
                if (!jsonObjIsCamelType) {
                    underScoreKey = camel2UnderScore(key);
                }
                // 类型嵌套的情况处理
                if (_this[key] instanceof DDBase) {
                    result[underScoreKey] = _this[key].class2JsonObj(jsonObjIsCamelType);
                }
                result[underScoreKey] = _this[key];
            }
        });
        return result;
    };
    DDBase.logger = new Logger('DDBase').use('console');
    return DDBase;
}());
export { DDBase };
